import React from "react";
import Danger from "../../alerts/Danger";
import Input from "../../form/input";
import Textarea from "../../form/textarea";
import RequiredAsterisk from "../../form/required_asterisk";

export default function CommunityFormBasic({ 
    nameValue, 
    nameOnChange, 
    descriptionValue, 
    descriptionOnChange, 
    subdomainValue, 
    subdomainOnChange, 
    teamSizeValue, 
    teamSizeOnChange, 
    marketingTimelineValue, 
    marketingTimelineOnChange, 
    isUpdateMode, 
    errors 
}) {

    return (
        <>
            <h3>Basic Information</h3>
            <div className="form-group text-left mb-4">
                <label className="mb-2">Organization/Studio Name <RequiredAsterisk /></label>
                <Input type="text" name="community_name" value={nameValue} onChange={nameOnChange} placeholder="Give the organization a name for your game(s)." />
                {errors && errors.name && errors.name.map(function (name, index) {
                    return <Danger message={name} key={index} />;
                })}
            </div>
            
            <div className="form-group text-left  mb-3">
                <label className="mb-2">Organization/Studio Description <RequiredAsterisk /></label>
                <Textarea type="text" name="community_description" onChange={descriptionOnChange} placeholder="Describe how you want the organization to be for your games." >{descriptionValue}</Textarea>
                {errors && errors.description && errors.description.map(function (name, index) {
                    return <Danger message={name} key={index} />;
                })}
            </div>

            <div className="form-group text-left  mb-4">
                <label className="mb-2">Organization/Studio Subdomain <RequiredAsterisk /></label>
                <Input type="text" name="community_subdomain" value={subdomainValue} onChange={subdomainOnChange} placeholder="Enter the subdomain for the organization." />
                <p className="small">The subdomain will the subdomain under glitch.fun. For example, mygame.glitch.fun. </p>
                {errors && errors.subdomain && errors.subdomain.map(function (name, index) {
                    return <Danger message={name} key={index} />;
                })}
            </div>

            {!isUpdateMode && (
                <>
                    
                    <div className="form-group text-left mb-4">
                        <label className="mb-2">What is your team size?</label>
                        <select
                            className="form-control"
                            value={teamSizeValue}
                            onChange={teamSizeOnChange}
                        >
                            <option value="">Select Team Size</option>
                            <option value="1">Solo Developer</option>
                            <option value="2">1-10</option>
                            <option value="3">11-50</option>
                            <option value="4">50-200</option>
                            <option value="5">200+</option>
                        </select>
                        {errors && errors.team_size_id && errors.team_size_id.map(function (error, index) {
                            return <Danger message={error} key={index} />;
                        })}
                    </div>

                    <div className="form-group text-left mb-4">
                        <label className="mb-2">How soon are you looking to start marketing?</label>
                        <select
                            className="form-control"
                            value={marketingTimelineValue}
                            onChange={marketingTimelineOnChange}
                        >
                            <option value="">Select Timeline</option>
                            <option value="1">Now</option>
                            <option value="2">In 2-3 months</option>
                            <option value="3">In 6 Months</option>
                            <option value="4">In 1 year</option>
                            <option value="5">Over 1 year</option>
                        </select>
                        {errors && errors.marketing_timeline_id && errors.marketing_timeline_id.map(function (error, index) {
                            return <Danger message={error} key={index} />;
                        })}
                    </div>
                </>
            )}
        </>
    );
}